import { actionCreation } from '@anna/anna-ws-utils';

const { generateActionTypes, generateActions } = actionCreation;

export const requestCSVActionTypes = generateActionTypes('REQUEST_CSV');
export const requestCSVCheckStatusActionTypes = generateActionTypes('REQUEST_CSV_CHECK_STATUS');
export const downloadCSVActionTypes = generateActionTypes('DOWNLOAD_CSV');

export const requestCSVActions = generateActions(requestCSVActionTypes, {
  common: ['format'],
  request: ['format'],
  success: ['requestId'],
});

export const requestCSVCheckStatusActions = generateActions(requestCSVCheckStatusActionTypes, {
  success: ['status'],
});

export const downloadCSVActions = generateActions(downloadCSVActionTypes, {
  common: ['downloadUrl'],
});
